import styles from './AppLoader.module.css';

function AppLoader() {
  return (
    <div className={styles.loadingScreen}>
        <span className={styles.loader}></span>
    </div>
  )
}

export default AppLoader
